import { Component, Input } from '@angular/core';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';

@Component({
  selector: 'ng-tickets-payment-resume',
  styleUrls: ['./payment-resume.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <div class="container-details-ticket">
      <div class="product-details">
        <p class="title-selected-ticket"> {{ productSale?.ticketProduct?.name }} </p>
        <p>{{productSale?.ticketProduct?.description}}</p>
      </div>

      <div class="amount-details">
        <p class="price-unit-ticket">Preço unitário:
          <b>{{ productSale?.ticketProduct?.value | currency:'BRL' }}</b></p>
        <p class="price-total-ticket">Preço total:
          <span>{{ (productSale?.ticketProduct?.value * productSale?.ticketAmount) | currency:'BRL' }} </span>
        </p>
      </div>

      <div class="qtd-details">
        <span>x{{ productSale?.ticketAmount }}</span>
      </div>
    </div>
  `
})
export class PaymentResumeComponent {

  @Input() productSale: ProductSale;
}
